export const SIDEBAR_ACCENT_CLASSNAMES = Object.freeze({
    COMPANY: {
        activeBg: "bg-tertiary-50!",
        hoverBg: "hover:bg-tertiary-30",
        indicator: "bg-tertiary-600",
        iconActive: "text-tertiary-600",
        iconHover: "group-hover:text-tertiary-600",
    },
    DEFAULT: {
        activeBg: "bg-primary-50!",
        hoverBg: "hover:bg-primary-30",
        indicator: "bg-primary-500",
        iconActive: "text-primary-500",
        iconHover: "group-hover:text-primary-500",
    },
} as const);
